export class AuthError extends Error {
  constructor(
    message: string,
    readonly status: number,
    public code?: string,
    public url?: string,
  ) {
    super(message);
  }

  static async fromResponse(response: Response): Promise<AuthError> {
    const status = response.status;

    const error = new AuthError(
      `Error ${status}: ${response.statusText} - Persona Auth API url: ${response.url}`,
      status,
    );

    try {
      const errorBody = await response.text();
      const parsed = JSON.parse(errorBody);
      if (status === 410 && parsed?.url) {
        error.url = parsed.url;
      }
      error.code = parsed.code;
    } catch {
      error.code = response.statusText;
    }

    return error;
  }
}
